// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 1. RESET BÁSICO – deixa tipografia mais consistente */
.scheduling-page,
.scheduling-page * {
  box-sizing: border-box;
  font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1.4;
}

/* 2. CONTAINER GERAL */
.scheduling-page .page-container {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  background: #f9fbfc;
}

/* 3. HEADER */
.scheduling-page .page-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: 8px;
  padding: 1.2rem 1.5rem;
  background: #0c5fb4;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}
.scheduling-page .page-header h1 {
  font-size: 1.35rem;
  font-weight: 600;
  color: white;
}
.scheduling-page .back-button {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0.3rem 0.4rem;
  border-radius: 0.5rem;
  transition: background 0.2s;
}
.scheduling-page .back-button:hover {
  background: rgba(255, 255, 255, 0.15);
}

/* 4. GRID DA ÁREA PRINCIPAL */
.scheduling-content {
  flex: 1 1;
  display: grid;
  gap: 2rem;
  padding: 2rem 1.5rem 3rem;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
}

/* 5. INFO-CARDS (Paciente, Médico, Procedimentos) */
.info-card {
  background: #fff;
  border: 1px solid #e3e9f0;
  border-radius: 0.75rem;
  padding: 1.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}
.info-card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: white;
}
.info-card-content h4 {
  margin: 0 0 0.15rem;
  font-size: 1.05rem;
}
.info-card-content p {
  margin: 0;
  font-size: 0.9rem;
  color: #475569;
}

/* 5.1 – lista de procedimentos */
.procedures-list-summary {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.procedures-list-summary li {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
}
.procedure-price {
  font-weight: 600;
  color: white;
}
.total-price-container {
  margin-top: 0.8rem;
  padding-top: 0.8rem;
  border-top: 1px solid #e3e9f0;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.total-price-value {
  color: #0c5fb4;
}

/* 6. FORMULÁRIO */
.scheduling-form {
  background: #fff;
  border: 1px solid #e3e9f0;
  border-radius: 0.75rem;
  padding: 1.75rem 1.75rem 2rem;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.form-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 0.5rem;
}
.form-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.form-group {
  flex: 1 1;
  min-width: 150px;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.form-group label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 500;
  margin-bottom: 0.15rem;
}
.form-group input,
.form-group select,
.form-group textarea {
  padding: 0.55rem 0.75rem;
  border: 1px solid #d0d5dd;
  border-radius: 0.5rem;
  font-size: 0.92rem;
}
.form-group input.error,
.form-group select.error {
  border-color: #e11d48;
}
.error-message {
  color: #e11d48;
  font-size: 0.8rem;
}

.comments-group textarea {
  resize: vertical;
  min-height: 96px;
}

/* 6.1 – nota de termos */
.scheduling-note {
  display: flex;
  gap: 0.5rem;
  background: #f1f5f9;
  padding: 0.8rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  color: #475569;
}
.scheduling-note svg {
  flex-shrink: 0;
  color: #0c5fb4;
}

/* 6.2 – botões */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.5rem;
}
.cancel-button,
.submit-button {
  border: 0;
  cursor: pointer;
  padding: 0.55rem 1.2rem;
  border-radius: 0.5rem;
  font-weight: 600;
}
.cancel-button {
  background: #f1f5f9;
  color: #475569;
}
.cancel-button:hover {
  background: #e2e8f0;
}
.submit-button {
  background: #0c5fb4;
  color: #fff;
}
.submit-button:hover {
  background: #08498b;
}

@media (prefers-color-scheme: dark) {
  /* paleta dark simples */
  .scheduling-page .page-container {
    background: #0f172a;
  }
  .page-header {
    background: #0c5fb4;
  }
  .info-card,
  .scheduling-form {
    background: #cbd5e1;
    border-color: #334155;
    box-shadow: none;
  }
  .info-card-header,
  .procedure-price,
  .info-card-content p,
  .total-price-value {
    color: #60a5fa;
  }
  .scheduling-note,
  .cancel-button {
    color: #cbd5e1;
  }
  .form-group input,
  .form-group select,
  .form-group textarea {
    background: #0f172a;
    color: #e2e8f0;
    border-color: #334155;
  }
  .scheduling-note {
    background: #1e293b;
  }
  .cancel-button {
    background: #334155;
  }
  .cancel-button:hover {
    background: #475569;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/schedulingPage.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;;EAEE,sBAAsB;EACtB,8EAA8E;EAC9E,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;;EAGE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;;;;IAIE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;;;IAGE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* 1. RESET BÁSICO – deixa tipografia mais consistente */\n.scheduling-page,\n.scheduling-page * {\n  box-sizing: border-box;\n  font-family: \"Inter\", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;\n  line-height: 1.4;\n}\n\n/* 2. CONTAINER GERAL */\n.scheduling-page .page-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100dvh;\n  background: #f9fbfc;\n}\n\n/* 3. HEADER */\n.scheduling-page .page-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  border-radius: 8px;\n  padding: 1.2rem 1.5rem;\n  background: #0c5fb4;\n  color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n}\n.scheduling-page .page-header h1 {\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: white;\n}\n.scheduling-page .back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  padding: 0.3rem 0.4rem;\n  border-radius: 0.5rem;\n  transition: background 0.2s;\n}\n.scheduling-page .back-button:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n/* 4. GRID DA ÁREA PRINCIPAL */\n.scheduling-content {\n  flex: 1;\n  display: grid;\n  gap: 2rem;\n  padding: 2rem 1.5rem 3rem;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n}\n\n/* 5. INFO-CARDS (Paciente, Médico, Procedimentos) */\n.info-card {\n  background: #fff;\n  border: 1px solid #e3e9f0;\n  border-radius: 0.75rem;\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n}\n.info-card-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: white;\n}\n.info-card-content h4 {\n  margin: 0 0 0.15rem;\n  font-size: 1.05rem;\n}\n.info-card-content p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #475569;\n}\n\n/* 5.1 – lista de procedimentos */\n.procedures-list-summary {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n.procedures-list-summary li {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n}\n.procedure-price {\n  font-weight: 600;\n  color: white;\n}\n.total-price-container {\n  margin-top: 0.8rem;\n  padding-top: 0.8rem;\n  border-top: 1px solid #e3e9f0;\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n}\n.total-price-value {\n  color: #0c5fb4;\n}\n\n/* 6. FORMULÁRIO */\n.scheduling-form {\n  background: #fff;\n  border: 1px solid #e3e9f0;\n  border-radius: 0.75rem;\n  padding: 1.75rem 1.75rem 2rem;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n.form-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem;\n}\n.form-row {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n.form-group {\n  flex: 1;\n  min-width: 150px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.form-group label {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-weight: 500;\n  margin-bottom: 0.15rem;\n}\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 0.55rem 0.75rem;\n  border: 1px solid #d0d5dd;\n  border-radius: 0.5rem;\n  font-size: 0.92rem;\n}\n.form-group input.error,\n.form-group select.error {\n  border-color: #e11d48;\n}\n.error-message {\n  color: #e11d48;\n  font-size: 0.8rem;\n}\n\n.comments-group textarea {\n  resize: vertical;\n  min-height: 96px;\n}\n\n/* 6.1 – nota de termos */\n.scheduling-note {\n  display: flex;\n  gap: 0.5rem;\n  background: #f1f5f9;\n  padding: 0.8rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 0.85rem;\n  color: #475569;\n}\n.scheduling-note svg {\n  flex-shrink: 0;\n  color: #0c5fb4;\n}\n\n/* 6.2 – botões */\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n}\n.cancel-button,\n.submit-button {\n  border: 0;\n  cursor: pointer;\n  padding: 0.55rem 1.2rem;\n  border-radius: 0.5rem;\n  font-weight: 600;\n}\n.cancel-button {\n  background: #f1f5f9;\n  color: #475569;\n}\n.cancel-button:hover {\n  background: #e2e8f0;\n}\n.submit-button {\n  background: #0c5fb4;\n  color: #fff;\n}\n.submit-button:hover {\n  background: #08498b;\n}\n\n@media (prefers-color-scheme: dark) {\n  /* paleta dark simples */\n  .scheduling-page .page-container {\n    background: #0f172a;\n  }\n  .page-header {\n    background: #0c5fb4;\n  }\n  .info-card,\n  .scheduling-form {\n    background: #cbd5e1;\n    border-color: #334155;\n    box-shadow: none;\n  }\n  .info-card-header,\n  .procedure-price,\n  .info-card-content p,\n  .total-price-value {\n    color: #60a5fa;\n  }\n  .scheduling-note,\n  .cancel-button {\n    color: #cbd5e1;\n  }\n  .form-group input,\n  .form-group select,\n  .form-group textarea {\n    background: #0f172a;\n    color: #e2e8f0;\n    border-color: #334155;\n  }\n  .scheduling-note {\n    background: #1e293b;\n  }\n  .cancel-button {\n    background: #334155;\n  }\n  .cancel-button:hover {\n    background: #475569;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
